<template>
  <v-layout :class="`justify-${justifyPosition} mb-3 mb-0`">
    <v-btn
      :style="style"
      class="br-10"
      color="secondary"
      @click.stop="checkIsLogged()"
    >AGENDAR CONSULTA</v-btn>

    <v-snackbar :timeout="3000" v-model="snackbar">{{ msg }}</v-snackbar>

    <v-dialog v-model="dialog" max-width="700px">
      <v-card class="px-5 pt-5">
        <v-card-text>
          <ComponentLogin mode="patient" v-on:data="resAuth" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ComponentLogin from './ComponentLogin';

export default {
  data() {
    return {
      dialog: false,
      snackbar: false,
      msg: '',
    };
  },
  components: {
    ComponentLogin,
  },
  props: {
    cod: String,
    justifyPosition: String,
    styleButton: String,
  },
  computed: {
    style() {
      return this.styleButton;
    },
  },
  methods: {
    checkIsLogged() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.goToScheduling();
      } else {
        this.dialog = true;
      }
    },
    resAuth(res) {
      if (res.isLogged) {
        this.dialog = false;
        this.snackbar = true;
        this.msg = res.msg;
        this.goToScheduling();
      }
    },
    goToScheduling() {
      this.$router.replace(`/psicologo/scheduling/${this.cod}`);
    },
  },
};
</script>
